import React from 'react';

interface ContentSectionProps {
  id: string;
  title: string;
  description: string;
  features: string[];
  ctaText: string;
  ctaHref: string;
  ctaTarget: string;
  isActive: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({
  id,
  title,
  description,
  features,
  ctaText,
  ctaHref,
  ctaTarget,
  isActive
}) => {
  return (
    <section 
      id={id} 
      className={`content-section ${isActive ? 'active' : ''}`}
    >
      <div className="section-content">
        <div className="section-text">
          <h2 className="section-title">{title}</h2>
          <p className="section-description">{description}</p>
          <ul className="feature-list">
            {features.map((feature, index) => (
              <li key={index} className="feature-item">
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <div className="section-visual">
          <div className="visual-placeholder">
            {id === 'vpn' && (
              <img 
                src="/images/vpn.png" 
                alt="VPN Services" 
                className="section-image"
              />
            )}
            {id === 'domain' && (
              <img 
                src="/images/domain-register.png" 
                alt="Domain Registration" 
                className="section-image"
              />
            )}
            {id === 'hosting' && (
              <img 
                src="/images/cloud-hosting.png" 
                alt="Cloud Hosting" 
                className="section-image"
              />
            )}
            {id === 'security' && (
              <img 
                src="/images/security-tools.png" 
                alt="Security Tools" 
                className="section-image"
              />
            )}
          </div>
        </div>
      </div>
      
      {/* CTA Button positioned after the illustration */}
      <div className="section-cta">
        <a 
          href={ctaHref} 
          target={ctaTarget}
          rel="noopener noreferrer"
          className="cta-button"
        >
          {ctaText}
        </a>
      </div>
    </section>
  );
};

export default ContentSection;
